import './WhatsNewCard.css';
import { Button, Card, CardContent, Chip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getLatestCardItems } from 'data/changelog';
import { TYPE_COLORS } from 'utils/constants';

const WhatsNewCard = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const cardItems = getLatestCardItems();
  const lang = i18n.language === 'es' ? 'esShort' : 'enShort';

  return (
    <Card variant="outlined" className="dashboard-card updates">
      <CardContent className="whats-new-content">

        <div className="whats-new-header">
          <Typography variant="body1" component="p" className="whats-new-title">
            {t('updates.cardTitle')}
          </Typography>
        </div>

        <ul className="whats-new-list">
          {cardItems.map((item, i) => (
            <li key={i} className="whats-new-item">
              <Chip
                label={t(`updates.types.${item.type}`)}
                size="small"
                className="whats-new-chip"
                sx={{
                  fontSize: '0.6rem',
                  height: 16,
                  backgroundColor: `${TYPE_COLORS[item.type]}22`,
                  color: TYPE_COLORS[item.type],
                  border: `1px solid ${TYPE_COLORS[item.type]}55`,
                  '& .MuiChip-label': { px: '6px' },
                }}
              />
              {item[lang]}
            </li>
          ))}
        </ul>

        <div className="whats-new-footer">
          <Button
            variant="outlined"
            size="large"
            onClick={() => navigate('/updates')}
            className="whats-new-cta-btn"
          >
            {t('updates.seeAll')}
          </Button>
        </div>

      </CardContent>
    </Card>
  );
};

export default WhatsNewCard;
